// This file contains constants used throughout the application.
const CONSTANTS_DETAILS_CONFIG = {
  APP_NAME: 'Drag & Drop Tool',
  APP_DEFAULT_LANGUAGE: 'en',
  FOLDER_BASE_URL: '/Folder',
  DEFAULT_STORAGE: 'Accolade',
  GET_FOLDER_ITEMS_URL: '/get-folder-items?folderPath=',
  FILE_TYPE_MAPPINGS: {
    pdf: { icon: 'picture_as_pdf', class: 'pdf' },
    'jpg|jpeg|png|gif|bmp|svg': { icon: 'image', class: 'image' },
    'xlsx|xls|csv': { icon: 'grid_view', class: 'excel' },
    'docx|doc': { icon: 'description', class: 'word' },
    'txt|md|log': { icon: 'notes', class: 'text' },
    'pptx|ppt': { icon: 'slideshow', class: 'powerpoint' },
    'zip|rar|7z|tar|gz': { icon: 'archive', class: 'archive' },
    'mp4|mkv|avi|mov|wmv|flv': { icon: 'movie', class: 'video' },
  },
  DISPLAYED_COLUMN: [
    'favorite',
    'fileName',
    'type',
    'uploadedBy',
    'uploadedOn',
    'modifiedOn',
    'size',
    'actions',
  ],
  RESTRICTED_FILE_TYPES: [
    'exe',
    'bat',
    'cmd',
    'scr',
    'com',
    'pif',
    'vbs',
    'js',
    'jar',
    'msi',
    'app',
    'deb',
    'rpm',
    'dmg',
    'pkg',
    'run',
    'bin',
    'sh',
    'ps1',
    'psm1',
    'ps2',
    'pssc',
    'psd1',
    'vb',
    'vbe',
    'ws',
    'wsf',
    'wsc',
    'wsh',
    'scf',
    'lnk',
    'inf',
    'reg',
    'dll',
    'sys',
    'drv',
  ],
  UPLOAD_CHUNKS_URL: '/FileUpload/upload-large-files',
  RENAME_URL: '/Folder/rename-object',
  FAVORITE_URL: '/Folder/update-favorite',
  MERGE_UPLOADS_URL: '/FileUpload/merge-uploaded-chunks',
  MERGE_SESSION_URL: '/FileUpload/merge-all-uploaded-chunks',
  GET_CHUNK_CONFIG_URL: '/FileUpload/get-chunks-configuration',
  UPDATE_CHUNK_CONFIG_URL: '/FileUpload/update-chunks-configuration',
  GET_USERPRIVILEGES_URL: '/Folder/get-all-user-roles',
  GENERATE_BUCKET_REPORT_URL: '/Folder/generate-bucket-report',
  UPLOAD_RESTRICTED_FOLDERS_NON_ACCOLADE: [
    'Corporate Innovation',
    'TestFolder',
    'APAC Innovation',
  ],
};
export const CONSTANTS_DETAILS = Object.freeze(CONSTANTS_DETAILS_CONFIG);
